export default "__VITE_ASSET__13998c28__"